// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef714933","453":"e713ba98","455":"d98c47f6","977":"8d28a9b2"}[chunkId] + ".chunk.js";
};